var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcContract(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "current",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.90469 2.84292V4.39053H13.0951V2.84292C13.0951 2.67268 12.9558 2.5334 12.7856 2.5334H7.21421C7.04397 2.5334 6.90469 2.67268 6.90469 2.84292ZM5.04756 4.39053V2.84292C5.04756 1.64739 6.01868 0.67627 7.21421 0.67627H12.7856C13.9811 0.67627 14.9522 1.64739 14.9522 2.84292V4.39053V5.62861V19.2476H5.04756V5.62861V4.39053ZM2.57139 4.39053H3.80947V19.2476H2.57139C1.20562 19.2476 0.0952148 18.1372 0.0952148 16.7714V6.8667C0.0952148 5.50094 1.20562 4.39053 2.57139 4.39053ZM17.4284 19.2476H16.1903V4.39053H17.4284C18.7942 4.39053 19.9046 5.50094 19.9046 6.8667V16.7714C19.9046 18.1372 18.7942 19.2476 17.4284 19.2476Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcContract);
export default __webpack_public_path__ + "static/media/ic_contract.56368469126464539bce7bfcdc7d4092.svg";
export { ForwardRef as ReactComponent };